import script from "./live.vue?vue&type=script&setup=true&name=Live&lang=js"
export * from "./live.vue?vue&type=script&setup=true&name=Live&lang=js"

import "./live.vue?vue&type=style&index=0&id=109a3305&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109a3305"]])

export default __exports__